import { render, staticRenderFns } from "./Secretarias.vue?vue&type=template&id=053be210"
import script from "./Secretarias.vue?vue&type=script&lang=js"
export * from "./Secretarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports